export default __webpack_public_path__ + "static/media/NorthernLights.68de6af2.jpg";